import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e29405"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-results" }
const _hoisted_2 = {
  key: 0,
  class: "search-results__text"
}
const _hoisted_3 = {
  key: 1,
  class: "search-results__text"
}
const _hoisted_4 = {
  key: 1,
  class: "search-results__loading loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "loading__text" }, "Ищем подходящие анкеты ...", -1 /* HOISTED */))

import ListCards from "@/searchSection/components/SearchResults/ListCards.vue";
import { computed, ComputedRef, Ref, ref } from "vue"
import SpinnerIcon from "@/common/icons/SpinnerIcon.vue";
import pButton from '@/common/pButton/pButton.vue'
import { useResultsStore } from "@/searchSection/store/resultsStore";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";

const countOnStep: number = 10


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResults',
  setup(__props) {

const resultsStore = useResultsStore()
const step: Ref<number> = ref(1)
const searchWasNotStarted = computed(() => resultsStore.results === null)
const resultsIsEmpty = computed(() => resultsStore.results?.length === 0)
const getSlicedCards: ComputedRef<ProfileCardInterface[]> = computed(() => {
  if (resultsStore.results === null) {
    return []
  }
  return resultsStore.results.slice(0, step.value * countOnStep)
})
const showButtonMore: ComputedRef<boolean> = computed(() => {
  if (resultsIsEmpty.value) {
    return false
  }
  
  return Math.ceil((resultsStore.results ? resultsStore.results.length : 1) / countOnStep) !== step.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(resultsStore).resultsLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (searchWasNotStarted.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Для поиска девушек выберите нужные параметры и нажмите кнопку \"Искать\". "))
            : _createCommentVNode("v-if", true),
          (resultsIsEmpty.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " По вашему запросу ничего не найдено "))
            : _createCommentVNode("v-if", true),
          (!searchWasNotStarted.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(ListCards, { list: getSlicedCards.value }, null, 8 /* PROPS */, ["list"]),
                (showButtonMore.value)
                  ? (_openBlock(), _createBlock(pButton, {
                      key: 0,
                      class: "search-results__show-more",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (step.value++))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Показать еще ")
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_unref(resultsStore).resultsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(SpinnerIcon, { class: "loading__icon" }),
          _hoisted_5
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})